



















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import MapView from '../../mapview/Map.vue'
import LeafletMapView from '../../mapview/LeafletMap.vue'
import Node from '@/models/Node'
import Vector2 from '@/models/Vector2'
import ImageInput from '@/components/ImageInput.vue'
import Project from '@/models/Project'
import BTextareaLimited from '@/components/input_limited/BTextareaLimited.vue';
import BFormInputLimited from '@/components/input_limited/BFormInputLimited.vue';
import ProjectUsers from '@/components/ProjectUsers.vue';
import { PacketType } from '@/models/Packet';
import { SendPacket } from '@/networking/SendPacket';
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue';

@Component({
	components: {
		MapView,
        ImageInput,
        ProjectUsers,
		LeafletMapView,
		BTextareaLimited,
		BFormInputLimited,
		SubscriptionPanel
	},
	watch: {
		"projectData.type": function (cur:string, old:string){
			let tg = this as any;
			let data = tg.projectData;
			if (data.background_image)
			{
				delete data.background_image;
			}
			if (data.coords)
			{
				delete data.coords;
			}

			// Clear it if we're not moving between default/image
			if (!((old == 'default' && cur == 'image') || (old == 'image' && cur == 'default')))
			{
				tg.mapNodes.length = 0
				this.$set(this, 'selectedMapPin', null);
			}

			if (cur == 'image')
			{
				this.$set(data, 'background_image', '')
			}
			if (cur == 'map')
			{
				this.$set(data, 'coords', { latitude : 0, longitude : 0, zoom_level : 1 })
			}
			this.$set(this, 'projectData', data);
		}
    },
    computed: {
		...mapGetters([
			'checkUserManage',
			'checkUserGroupEdit',
			'checkAdmin'
		])
	},
})

export default class CreateProject extends Vue {
	@Prop(Object) readonly modal! : Object;
    @Prop(Project) readonly project! : Project;
	write_project : Project | null = null;
	tier: Number | null = null;

	loading = false;

	get isGlobalAdmin() : boolean
	{
		return !!(this.$store.getters.user && this.$store.getters.user.isAdmin);
	}

    mounted()
    {
        this.write_project = new Project;
		Object.assign(this.write_project, this.project)
		this.getTier();
	}
	
	async getTier()
	{
		this.tier = await this.$store.dispatch('getProjectSubscription', this.project.pid);
	}

	get isInputValid() : boolean {
		if (this.projectName.trim() == '') return false;
		if (this.projectDescription.trim() == '') return false;
		if (this.projectData.type == 'image')
		{
			if ((this.projectData as any).background_image == '') return false;
			if (!this.$refs.imageInputComponent) return false;
			if (!(this.$refs.imageInputComponent as any).imageURLValid) return false;
		}
		return true;
	}

	mapOptions = [
		{value: 'default', text: 'Default World Map'},
		{value: 'image', text: 'Image (URL)'},
		{value: 'map', text: 'Map'},
		{value: 'none', text: 'None'}
	];
	
	emptyString = ''
	projectData = {type: 'default'};
    get projectName()
    {
        if (!this.write_project) return "";
        return this.write_project.name;
    }

    set projectName(value : string)
    {
        if (!this.write_project) return;
        this.write_project.name = value;
    }

	get projectDescription()
    {
        if (!this.write_project) return "";
        return this.write_project.description;
    }

    set projectDescription(value : string)
    {
        if (!this.write_project) return;
        this.write_project.description = value;
    }

	get projectWatermarkImage()
    {
        if (!this.write_project) return "";
        return this.write_project.watermarkImage;
    }

    set projectWatermarkImage(value : string)
    {
        if (!this.write_project) return;
        this.write_project.watermarkImage = value;
    }

	get projectWatermarkLink()
    {
        if (!this.write_project) return "";
        return this.write_project.watermarkLink;
    }

    set projectWatermarkLink(value : string)
    {
        if (!this.write_project) return;
        this.write_project.watermarkLink = value;
    }

	get projectMapNodes(){
		let arr : Object[] = [];
		for(let i = 0; i < this.mapNodes.length; ++i)
		{
			let node = (this.mapNodes as any)[i][1] as Node;
			arr.push({name: node.name, xCoord: node.position.x, yCoord: node.position.y});
		}
		return {nodes: arr};
    }
    
    async saveProject()
    {
        if (!this.write_project) return;

        let data = new FormData();
        data.append("pid", this.write_project.id);
        data.append("name", this.write_project.name);
        data.append("description", this.write_project.description);
        if (this.isGlobalAdmin)
        {
            data.append("watermarkImage", this.write_project.watermarkImage || "");
            data.append("watermarkLink", this.write_project.watermarkLink || "");
        }
        try
        {
            this.$emit("begin-save");
			await this.$http.put("projects", data);
			SendPacket(PacketType.ProjectNotifyMetadataChanged, {});
            this.$emit("saved");
        }
        catch(er)
        {
            this.$emit("save-failed");
            if (er.response && er.response.data && er.response.data.error)
            {
                alert(er.response.data.error);
            }
            console.error(er);
        }
        this.$emit("end-save");
    }

	mapNodes : Object[] = []
	selectedMapPin: Node = <any>null;

	imgMapClicked(x : number, y : number){
		let vec = new Vector2(x, this.projectData.type == 'map' ? y : 1-y);
		if (this.selectedMapPin)
		{
			this.$set(this.selectedMapPin, 'position', vec);
		}
		else
		{
			let n = new Node();
			n.position = vec
			n.name = "New Map Pin"
			
			// This is weird bc of the way that the getter works
			this.mapNodes.push([this.mapNodes.length, n]);
			this.$set(this, 'selectedMapPin', n)
		}
	}

	imgNodeClicked(node : Node){
		this.$set(this, 'selectedMapPin', node)
	}
	
	gooMapCenterChange(center : any){
		console.log(`${center.lat}, ${center.lng}`);
		(this.projectData as any).coords.latitude = center.lat;
		(this.projectData as any).coords.longitude = center.lng;
	}

	gooMapZoomChange(zoom : any){
		(this.projectData as any).coords.zoom_level = zoom;
	}

	deleteSelectedNode(){
		if (!this.selectedMapPin)
		{
			return;
		}

		for(let i = 0; i < this.mapNodes.length; ++i)
		{
			let cur = (this.mapNodes as any)[i][1];
			if (cur == this.selectedMapPin)
			{
				this.mapNodes.splice(i, 1);
				break;
			}
		}
		this.$set(this, 'selectedMapPin', null)
	}

	saveSelectedNode()
	{
		this.$set(this, 'selectedMapPin', null)
	}
}
